/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { Filter, Setting, SettingAdd, SettingChange, SettingTable } from '@finbeat/react-toolkit';
import { AxiosInstance } from 'axios';
import ResTable from 'models/api/table';

export const getSettings = async (axios: AxiosInstance, params: Filter<Setting>) => {
    const { data } = await axios.get<ResTable<SettingTable>>('/webSettings', {
        params,
    });
    return data;
};

export const getSettingItem = async (axios: AxiosInstance, filter: SettingTable) => {
    const { data } = await axios.get<SettingTable>(`/webSettings/${filter.code}`);
    return data;
};

export const getSettingsExcel = async (
    axios: AxiosInstance,
    params: Filter<Setting>,
    culture?: string
) => {
    const { data } = await axios.get<Blob>('/webSettings/excel', {
        responseType: 'arraybuffer',
        params: { ...params, culture },
    });
    return data;
};

export const addSettingsItem = async (axios: AxiosInstance, item: SettingAdd) => {
    return await axios.post('/webSettings', item);
};

export const changeSettingsItem = async (axios: AxiosInstance, item: SettingChange) => {
    return await axios.put('/webSettings', item);
};

export const getWebSettings = async (axios: AxiosInstance, params?: Filter<Setting>) => {
    const { data } = await axios.get<SettingTable[]>('/webSettings/settings', {
        params,
    });
    return data;
};

export const getAppSettings = async (axios: AxiosInstance) => {
    const { data } = await axios.get<SettingTable[]>('/webSettings/app-settings');
    return data;
};

export const deleteSettingItem = async (axios: AxiosInstance, code: string) => {
    return await axios.delete(`/webSettings/${code}`);
};

export const getDbDateTime = async (axios: AxiosInstance) => {
    const { data } = await axios.get<string>('/websettings/dbDateTime');
    return data;
};
